import { NgModule } from '@angular/core';
import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { BadgeModule } from 'primeng/badge';
import { BlockUIModule } from 'primeng/blockui';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CarouselModule } from 'primeng/carousel';
import { CascadeSelectModule } from 'primeng/cascadeselect';
import { ChartModule } from 'primeng/chart';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { ColorPickerModule } from 'primeng/colorpicker';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DataViewModule } from 'primeng/dataview';
import { DatePickerModule } from 'primeng/datepicker';
import { DialogModule } from 'primeng/dialog';
import { DockModule } from 'primeng/dock';
import { DragDropModule } from 'primeng/dragdrop';
import { DrawerModule } from 'primeng/drawer';
import { EditorModule } from 'primeng/editor';
import { FieldsetModule } from 'primeng/fieldset';
import { FileUploadModule } from 'primeng/fileupload';
import { FloatLabelModule } from 'primeng/floatlabel';
import { GalleriaModule } from 'primeng/galleria';
import { IconFieldModule } from 'primeng/iconfield';
import { ImageModule } from 'primeng/image';
import { InplaceModule } from 'primeng/inplace';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputIconModule } from 'primeng/inputicon';
import { InputMaskModule } from 'primeng/inputmask';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputOtpModule } from 'primeng/inputotp';
import { InputTextModule } from 'primeng/inputtext';
import { KeyFilterModule } from 'primeng/keyfilter';
import { KnobModule } from 'primeng/knob';
import { ListboxModule } from 'primeng/listbox';
import { MegaMenuModule } from 'primeng/megamenu';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { MessageModule } from 'primeng/message';
import { MeterGroupModule } from 'primeng/metergroup';
import { MultiSelectModule } from 'primeng/multiselect';
import { OrderListModule } from 'primeng/orderlist';
import { OrganizationChartModule } from 'primeng/organizationchart';
import { PaginatorModule } from 'primeng/paginator';
import { PanelModule } from 'primeng/panel';
import { PanelMenuModule } from 'primeng/panelmenu';
import { PasswordModule } from 'primeng/password';
import { PickListModule } from 'primeng/picklist';
import { PopoverModule } from 'primeng/popover';
import { ProgressBarModule } from 'primeng/progressbar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RatingModule } from 'primeng/rating';
import { RippleModule } from 'primeng/ripple';
import { ScrollerModule } from 'primeng/scroller';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { ScrollTopModule } from 'primeng/scrolltop';
import { SelectModule } from 'primeng/select';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SkeletonModule } from 'primeng/skeleton';
import { SliderModule } from 'primeng/slider';
import { SpeedDialModule } from 'primeng/speeddial';
import { SplitButtonModule } from 'primeng/splitbutton';
import { SplitterModule } from 'primeng/splitter';
import { StepperModule } from 'primeng/stepper';
import { StepsModule } from 'primeng/steps';
import { StyleClassModule } from 'primeng/styleclass';
import { TableModule } from 'primeng/table';
import { TabsModule } from 'primeng/tabs';
import { TagModule } from 'primeng/tag';
import { TerminalModule } from 'primeng/terminal';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { TimelineModule } from 'primeng/timeline';
import { ToastModule } from 'primeng/toast';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { ToolbarModule } from 'primeng/toolbar';
import { TooltipModule } from 'primeng/tooltip';
import { TreeModule } from 'primeng/tree';
import { TreeSelectModule } from 'primeng/treeselect';
import { TreeTableModule } from 'primeng/treetable';

const PrimeNG = [
	AccordionModule,
	AutoCompleteModule,
	AvatarGroupModule,
	AvatarModule,
	BadgeModule,
	BlockUIModule,
	BreadcrumbModule,
	ButtonModule,
	CardModule,
	CarouselModule,
	CascadeSelectModule,
	ChartModule,
	CheckboxModule,
	ChipModule,
	ColorPickerModule,
	ConfirmDialogModule,
	ConfirmPopupModule,
	ContextMenuModule,
	DataViewModule,
	DatePickerModule,
	DialogModule,
	DockModule,
	DragDropModule,
	DrawerModule,
	EditorModule,
	FieldsetModule,
	FileUploadModule,
	FloatLabelModule,
	GalleriaModule,
	IconFieldModule,
	ImageModule,
	InplaceModule,
	InputGroupAddonModule,
	InputGroupModule,
	InputIconModule,
	InputMaskModule,
	InputNumberModule,
	InputOtpModule,
	InputTextModule,
	KeyFilterModule,
	KnobModule,
	ListboxModule,
	MegaMenuModule,
	MenubarModule,
	MenuModule,
	MessageModule,
	MeterGroupModule,
	MultiSelectModule,
	OrderListModule,
	OrganizationChartModule,
	PaginatorModule,
	PanelMenuModule,
	PanelModule,
	PasswordModule,
	PickListModule,
	PopoverModule,
	ProgressBarModule,
	ProgressSpinnerModule,
	RadioButtonModule,
	RatingModule,
	RippleModule,
	ScrollerModule,
	ScrollPanelModule,
	ScrollTopModule,
	SelectButtonModule,
	SelectModule,
	SkeletonModule,
	SliderModule,
	SpeedDialModule,
	SplitButtonModule,
	SplitterModule,
	StepsModule,
	StepperModule,
	StyleClassModule,
	TableModule,
	TabsModule,
	TagModule,
	TerminalModule,
	TieredMenuModule,
	TimelineModule,
	ToastModule,
	ToggleButtonModule,
	ToggleSwitchModule,
	ToolbarModule,
	TooltipModule,
	TreeModule,
	TreeSelectModule,
	TreeTableModule,
];

@NgModule({
	declarations: [],
	imports: [PrimeNG],
	exports: [PrimeNG],
})
export class PrimeNGModule {}
